import React, { useState, useEffect } from "react";
import { getAllListings } from "../../../../requests/listingsApi";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const MerchantListings = ({ merchant }) => {

  const navigate = useNavigate()
  const [rows, setRows] = useState([]);
  const allChecked = rows?.every((row) => row.selected);
  const pendingReview = rows?.filter((r) => r.status === "pending")

  const handleSelectAll = () => {
    const newValue = !allChecked;
    setRows(rows.map((row) => ({ ...row, selected: newValue })));
  };

  const handleRowSelect = (index) => {
    const updated = [...rows];
    updated[index].selected = !updated[index].selected;
    setRows(updated);
  };

  const getAllListingsFun = async() => {
    const data = await getAllListings(merchant)
    if(data.status) {
       setRows(data.data)
    }
  }

  useEffect(() => {
     if(merchant) {
      getAllListingsFun()
     }
  }, [merchant])

  return (
    <div className="details-wrap">
      <h2>Listing Approval queue</h2>
      <div className="table-responsive">
        <table className="table table-striped listing-review">
          <thead className="table-dark">
            <tr>
              {/* <th>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </th> */}
              <th>Listing Name</th>
              <th>Category</th>
              <th>Status</th>
              <th>Submit Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pendingReview?.length ? pendingReview.map((row, i) => (
              <tr key={i}>
                {/* <td>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={() => handleRowSelect(i)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td> */}
                <td>{row.productName}</td>
                <td>{row.category}</td>
                <td>{row.status}</td>
                <td>{moment(row.creates_at).format('YYYY-MM-DD')}</td>
                <td>
                  <div className="more-details" onClick={() => navigate("/listing-details", {state: { data: row }})}>
                    View Details{" "}
                    <img
                      src="/images/icons/detail-arrow.svg"
                      alt="detail-arrow"
                    />
                  </div>
                </td>
              </tr>
            )): (<tr>
            <td colSpan="6" className="text-center">No records found</td>
          </tr>)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MerchantListings;
